import { money } from '../utils'

export default {
  methods: {
    formatMoney: money
  }
}
